// extracted by mini-css-extract-plugin
module.exports = {"block":"Button_block__3pqAG","small":"Button_small__Th5EV","medium":"Button_medium__29g7-","outline":"Button_outline__21oiJ","fluid":"Button_fluid__1XP6d"};